var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceExternalPower01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "energy_00000122694181076918782710000000505842745357748118_",
    transform: "translate(0 -61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142_00000124859101032260004030000013182382978458426300_",
    d: "M198.1,491.7l151-241.8H266l53.7-107.5H214.9 l-44.8,188.1h69.4L198.1,491.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143_00000019663023579014850210000014514898436692355478_",
    d: "M106.1,353.9l-4.9-27.7L16,340.9l4.9,27.7 L106.1,353.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144_00000116212404858692181980000002809871313639717307_",
    d: "M405.9,272.6l4.9,27.7l85.2-14.6l-4.9-27.7 L405.9,272.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145_00000052102917191504153590000011847917026476183479_",
    d: "M115,378.4l-74,42.2L55,444.9l74-42.2L115,378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146_00000067205120527895155870000018136576702656652201_",
    d: "M471,205.9L457,181.5l-74,42.2l14.1,24.4L471,205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147_00000065776417901808259390000009684800751459028906_",
    d: "M129.1,223.7l-74-42.2L41,205.9l74,42.2L129.1,223.7z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148_00000021841508908151893050000009541317790407526577_",
    d: "M471,420.6l-74-42.2l-14.1,24.4l74,42.2L471,420.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149_00000165925823087799167660000013341573159591358858_",
    d: "M106.1,272.6L20.9,258L16,285.6l85.2,14.6 L106.1,272.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150_00000039107364757505163600000006830351238186830746_",
    d: "M405.9,353.9l85.2,14.6l4.9-27.7l-85.2-14.6 L405.9,353.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceExternalPower01);
export default __webpack_public_path__ + "static/media/deviceExternalPower-01.1d483c20622f79b04731e15c0ff34df5.svg";
export { ForwardRef as ReactComponent };